import { render } from "./Register.vue?vue&type=template&id=79f519ea&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=79f519ea&lang=scss&scoped=true"

import exportComponent from "/home/jiaxf/prod/fltrp-dams-admin-ui/builds/VjEGYzGkB/0/unilearn/unilearn-web-vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f519ea"]])

export default __exports__